import { Component, OnInit } from '@angular/core';
import {AuthService} from "../services/auth.service";
import {DropdownService} from "../services/dropdown.service";
import {icJWT_Account, LabInfo, PendingChangeList} from "../NIBINInterface";
import {MatDialog} from "@angular/material/dialog";
import {NavigationEnd, Router} from "@angular/router";
import {DataChangeRequestService} from "../services/DataChangeRequest.service";
import {NewIncidentFormComponent} from "./incidents/new-incident-form/new-incident-form.component";
import {DetailChangeViewComponent} from "./detail/detail-change-view/detail-change-view.component";
import {formatDate} from "@angular/common";



@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [DropdownService, DataChangeRequestService]
})
export class DashboardComponent implements OnInit {
  NIBIN_VERSION: string = "2.0.9";
  user: icJWT_Account = <icJWT_Account>{};
  pendingNotifications:number = 0;
  pendingChangesList: PendingChangeList[] = [];
  pendingEditList: any[]= [];
  mainDisplayState: string = '';

  fullLabName: string = "";
  LabImg: string = "";
  UserExpire: any = "";
  constructor(private authService: AuthService,private dropdownService: DropdownService, private dataChangeRequestService:DataChangeRequestService, public dialog:MatDialog, private router: Router) {
    this.user = this.authService.getUser()
    let d = new Date(parseInt(this.user.token_expire) * 1000)
    //this.UserExpire=this.user.token_expire? d.getUTCMonth()+ "/"+ d.getUTCDate()+ "/"+ d.getUTCFullYear() + " " + d.getHours() + ":"+d.getMinutes() : "";
    this.UserExpire = this.user.token_expire? formatDate(d, 'short','en-US'): ""
    this.loadDeptImg()
    this.getUpdatedPendingNotificationsCount()

    if(router.url === "/dashboard/incidents")
      this.mainDisplayState='INCIDENTS'
    else if(router.url === "/dashboard/reports")
      this.mainDisplayState='REPORTS'
    else if(router.url === "/dashboard")
      this.mainDisplayState='REPORTS'
    else if(router.url === "/dashboard/email")
      this.mainDisplayState='MANAGE_EMAIL'

  }

  ngOnInit(): void {}
  doLogout(): void{ this.authService.logout()}
  setDisplayState(state:string): void{
    this.mainDisplayState=state
  }

  async loadDeptImg(): Promise<void>{
    let  lab: LabInfo = await this.dropdownService.getLabInfo(this.user.CurrentDept);
    this.LabImg=lab.LAB_IMAGE;
    this.fullLabName=lab.LAB_FN;
  }

  getUpdatedPendingNotificationsCount() {
    this.dataChangeRequestService.GetPendingChangeCount(this.user.CurrentDept).then((r)=>{
      this.pendingNotifications = r.AnyData
    })

    this.dataChangeRequestService.GetPendingChangesList(this.user.CurrentDept).then((r)=>{
      this.pendingChangesList = this.dataChangeRequestService.parseChangeList(r.AnyData)
    })

    //pendingEditList
    this.dataChangeRequestService.GetPendingEditsList(this.user.CurrentDept).then((r)=>{
      console.log(r);
      this.pendingEditList = r
    });

  }

  switchDept(dept: string) {
    this.authService.switchDept(dept?.toLowerCase())
  }

  showChangesDialog(){
    let dia = this.dialog.open(DetailChangeViewComponent, {
      width: '80%',
      height: '80%'
    })
    dia.componentInstance.PendingList = this.pendingChangesList
    dia.componentInstance.EditList = this.pendingEditList
    dia.componentInstance.RefreshTrigger.subscribe(r=>{
      this.getUpdatedPendingNotificationsCount();
    })
  }

  async openStatsDashboard() {
    let url = await this.authService.GetNIBINDashboardURL()
    console.log(url)
    if(url)
      window.open(url, "_blank")
  }
}
